import React, { useState, useEffect } from 'react';
import EditGiftlistForm from '../Forms/EditGiftlistForm';
import EditConnectionForm from '../Forms/EditConnectionForm';
import useGlobal from '../../store';


const EditGiftlist = (props) => {
    
    const [connectionData, setConnectionData] = useState(null);
    const [isRemoving, setIsRemoving] = useState(false);
    const [isRemoved, setIsRemoved] = useState(false);

    const [response, userActions] = useGlobal(
        state => state.response,
        actions => actions.userActions
    );
    const [loggedInUser] = useGlobal(
        state => state.user
    );
    const [activeGiftlist] = useGlobal(
        state => state.activeGiftlist
    );
    const [giftlists] = useGlobal(
        state => state.giftlists
    );

    useEffect(() => {
        if(!loggedInUser || !activeGiftlist) {
            return;
        }
        let conn = giftlists.filter(gl => gl.userID === activeGiftlist.user.userID);
        if(conn.length > 0) {
            console.log('SETTING CONNECTION DATA', conn[0]);
            setConnectionData(conn[0]);
        }
    }, [loggedInUser, giftlists, activeGiftlist]);

    useEffect(() => {
        console.log('INDIVIDUAL GIFTLIST');
        if(!response || response.type !== "deletegiftlist") {
            return;
        }
        setIsRemoving(false);
        setIsRemoved(true);
    }, [response]);

    const removeGiftList = () => {
        setIsRemoving(true);
        userActions.removeGiftlist(props.user.userID);
    }

    return (<>
        <div className="kt-portlet">
            <div className="kt-portlet__head kt-portlet__head--lg">
                <div className="kt-portlet__head-label">
                    <h3 className="kt-heading kt-heading--lg">Gift List Settings</h3>
                </div>
                <div className="kt-portlet__head-toolbar">
                    { isRemoved ? <></> :
                        <button onClick={() => removeGiftList()} className="btn btn-bold btn-warning btn-upper">
                            <i className="flaticon-delete"></i> <span className="kt-hidden-mobile">Remove List</span>
                            {isRemoving ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></> }
                        </button> }
                </div>
            </div>

            <div className="kt-portlet__body">
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <EditConnectionForm {...connectionData}></EditConnectionForm>
                    </div>
                    {connectionData 
                    && connectionData.addedBy 
                    && connectionData.addedBy.userID === loggedInUser.userID 
                    && connectionData.isUser !== "1" ?
                    <div className="col-sm-12 col-md-6">
                        <EditGiftlistForm {...props.user}></EditGiftlistForm>
                    </div> :<></> }
                </div>
                
            </div>

        </div>
    </>);

}
export default EditGiftlist;